import classNames from 'classnames';
import {IInputCaptionPublicProps, InputCaption} from 'components/InputCaption';
import React, {ChangeEventHandler, TextareaHTMLAttributes, useCallback, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';

export interface IProps extends TextareaHTMLAttributes<HTMLTextAreaElement>, IInputCaptionPublicProps {
    disabled?: boolean;
    labelText?: string;
    placeholder?: string;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, IProps>(function TextArea(
    {errorText, captionText, disabled, onChange, labelText, className, ...restTextAreaAttributes},
    ref,
) {
    const [isFilled, setIsFilled] = useState<boolean>(Boolean(restTextAreaAttributes.value));

    const handleTextAreaChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
        (event) => {
            const target = event.target;
            setIsFilled(Boolean(target.value));

            if (onChange) {
                onChange(event);
            }
        },
        [onChange],
    );

    return (
        <>
            <label className={style.textArea}>
                <textarea
                    {...restTextAreaAttributes}
                    className={classNames(style.textAreaOriginal, 'textarea-original', className, {
                        [style.textAreaOriginalFilled]: isFilled,
                        [style.textAreaOriginalNonLabel]: !labelText,
                    })}
                    disabled={disabled}
                    onChange={handleTextAreaChange}
                    ref={ref}
                />
                <div
                    className={classNames(style.textAreaFrame, 'textarea-frame', {
                        [style.textAreaFrameError]: errorText,
                        [style.textAreaFrameDisabled]: disabled,
                    })}
                />
                {labelText && (
                    <Typography className={style.textAreaLabel} color={'gray100'} variant={'label-14-r-fluid'}>
                        {labelText}
                    </Typography>
                )}
            </label>
            <InputCaption captionText={captionText} disabled={disabled} errorText={errorText} />
        </>
    );
});
